import { FunctionComponent, ReactElement } from 'react';
import { Typography, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import AuthCardLayout from '../../layouts/auth-card-layout/AuthCardLayout';

interface InstructionSentProps {
	email: string;
}

const InstructionSent: FunctionComponent<InstructionSentProps> = ({ email }): ReactElement => (
	<AuthCardLayout title="Instructions sent!">
		<Stack direction="column" mt={3} spacing={3}>
			<Typography variant="body1" color="text.secondary">
				Hi {email}, a message with instructions has been sent to your email. Please follow the
				instructions to reset password.
			</Typography>
			<Button component={Link} to="/auth/login" variant="contained" size="large" fullWidth>
				Back to login
			</Button>
		</Stack>
	</AuthCardLayout>
);

export default InstructionSent;
